import camelCase from 'to-camel-case';
var namespacer = '/';
export default (function (type) {
  return type.indexOf(namespacer) === -1 ? camelCase(type) : type.split(namespacer).map(camelCase).join(namespacer);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/camelCase.js
// module id = 775
// module chunks = 35